import { useState } from "react";
import { Property } from "@/types/property";

export const useCalendarSelection = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(
    null,
  );
  const [showModal, setShowModal] = useState(false);

  const openModal = (date: Date, property: Property) => {
    setSelectedDate(date);
    setSelectedProperty(property);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedDate(null);
    setSelectedProperty(null);
    setShowModal(false);
  };

  return {
    selectedDate,
    selectedProperty,
    showModal,
    openModal,
    closeModal,
  };
};
